module.exports = __webpack_public_path__ + "static/img/banner_reveal.3fa5bf13.png";